export const UNKNOWN_ROLE = "unknown_admin_role";
export const SYSTEM_ROLE = "system_admin_role";
export const SALES_ROLE = "sales_admin_role";
export const DEVELOPER_ROLE = "developer_admin_role";
export const SUPPORT_ROLE = "support_admin_role";
export const DEVOPS_ROLE = "devops_admin_role";

export const adminRoles = [
    UNKNOWN_ROLE,
    SYSTEM_ROLE,
    SALES_ROLE,
    DEVELOPER_ROLE,
    SUPPORT_ROLE,
    DEVOPS_ROLE
];

export const selectableAdminRoles = [
    SYSTEM_ROLE,
    SALES_ROLE,
    DEVELOPER_ROLE,
    SUPPORT_ROLE,
    DEVOPS_ROLE
];

export const adminRoleToString = {
    [UNKNOWN_ROLE]: "Unknown role",
    [SYSTEM_ROLE]: "System Admin",
    [SALES_ROLE]: "Sales",
    [DEVELOPER_ROLE]: "Developer",
    [SUPPORT_ROLE]: "Support",
    [DEVOPS_ROLE]: "DevOps",
};

const ROLE_STORAGE_KEY = "role";

export const saveUserRole = (role) => {
    localStorage.setItem(ROLE_STORAGE_KEY, role);
};

export const getUserRole = () => {
    return localStorage.getItem(ROLE_STORAGE_KEY);
};
